import { render } from "./coordenadoresAdd.vue?vue&type=template&id=26316fd6"
import script from "./coordenadoresAdd.vue?vue&type=script&lang=js"
export * from "./coordenadoresAdd.vue?vue&type=script&lang=js"

import "./coordenadoresAdd.vue?vue&type=style&index=0&id=26316fd6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__